const MONTH_LABELS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/**
 * Default dashboard display timescale (MMM-YY) from model time properties.
 * Matches `TimeRangeFilter` bootstrap so data loads before the picker mounts.
 */
export default function defaultDisplayTimeFilterFromModel(
  timeProperties?: {
    starting_period?: string | Date | null;
    time_granularity?: string | null;
    plan_duration_periods?: number | null;
  } | null,
): { start: string; end: string } | null {
  if (!timeProperties?.starting_period) {
    return null;
  }

  const timeGranularity = (timeProperties.time_granularity ?? 'M').toString();
  const rawPeriods = Number(timeProperties.plan_duration_periods);
  const duration = Number.isNaN(rawPeriods)
    ? timeGranularity.toLowerCase() === 'm'
      ? 36
      : 3
    : rawPeriods;

  const start = new Date(timeProperties.starting_period);
  const end = new Date(timeProperties.starting_period);
  end.setMonth(end.getMonth() + (timeGranularity.toLowerCase() === 'm' ? duration : duration * 12));

  const format = (date: Date) => {
    if (timeGranularity.toLowerCase() === 'y') {
      return date.getFullYear().toString();
    }
    return `${MONTH_LABELS[date.getMonth()]}-${date.getFullYear().toString().slice(-2)}`;
  };

  return { start: format(start), end: format(end) };
}
